import type { RowData } from '@tanstack/react-table';
import { TanStackTableCSVButton } from './csv-button';
import type { AppTable } from './features';
import { TanStackTablePrintButton } from './print-button';

type ReportActionsProps<T extends RowData> = {
  table: AppTable<T> | null;
  title: string;
};

export function ReportActions<T extends RowData>({ table, title }: ReportActionsProps<T>) {
  return (
    <>
      <TanStackTablePrintButton table={table} title={title} />
      <TanStackTableCSVButton
        table={table}
        filename={`${title.toLowerCase().replace(/ /g, '-')}.csv`}
      />
    </>
  );
}
